export default {
  init() {
    // var classes = $('.featured-product').attr('class').split(' ');
    // var categoryClasses = [];
    // var taxononySlug = 'product_category-';
    // for (var i = classes.length - 1; i >= 0; i--) {
    //   if (classes[i].startsWith(taxononySlug)) {
    //     categoryClasses.push(classes[i].replace(taxononySlug, ''));
    //   }
    // }
    // for (var j = categoryClasses.length - 1; j >= 0; j--) {
    //   $('.menu-'+categoryClasses[j]).addClass('active');
    // }
    $('.video-carousel').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
